import { Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private notifs: NotificationService) {}

  success(message?: string) {
    this.notifs.show({
      type: { style: 'success', icon: true },
      animation: { type: 'fade', duration: 100 },
      hideAfter: 1000,
      content: message!, //? this.translate.instant(message) : 'Success',
      position: { vertical: 'bottom', horizontal: 'center' },
    });
  }

  showError(error: any) {
    console.log(error);
    const message =
      (error.error ? error.error.message : error.message) || error.messageBody;

    this.notifs.show({
      type: { style: 'error', icon: true },
      animation: { type: 'slide', duration: 400 },
      hideAfter: 4000,
      content: message,
      position: { vertical: 'bottom', horizontal: 'center' },
    });
  }
}
